export const faqs = [
  {
    question: 'What happens after I start an assessment?',
    answer: 'You complete an online health assessment that asks about your goals and health history. A licensed provider reviews the information and decides whether a treatment plan is appropriate for you.',
  },
  {
    question: 'Will I automatically receive a prescription?',
    answer: 'No. Prescription treatment requires an evaluation, and eligibility is not guaranteed. Your provider will explain the available options if treatment is appropriate.',
  },
  {
    question: 'What treatments may be available for weight loss?',
    answer: 'Semaglutide and tirzepatide are prescription treatment options that may be considered by a licensed provider. Availability and suitability vary by patient and location.',
  },
  {
    question: 'How does ED care work?',
    answer: 'You share your health history and goals in an online assessment. If appropriate, a licensed provider can review potential ED treatment options and explain next steps.',
  },
  {
    question: 'How are prescribed treatments delivered?',
    answer: 'When prescribed, treatment may be fulfilled by a licensed pharmacy and shipped in discreet packaging. Fulfillment and availability can vary.',
  },
  {
    question: 'Do I need insurance?',
    answer: 'VT.co is designed for cash-pay care. Your assessment will show the next step for your situation, and any treatment costs or availability are shared before you continue.',
  },
  {
    question: 'What if I have an emergency?',
    answer: 'VT.co is not for emergencies. Call 911 or seek urgent medical care if you have a medical emergency.',
  },
] as const;
